import { render, staticRenderFns } from "./guidanceVideos.vue?vue&type=template&id=a10ee058&scoped=true"
import script from "./guidanceVideos.vue?vue&type=script&lang=js"
export * from "./guidanceVideos.vue?vue&type=script&lang=js"
import style0 from "./guidanceVideos.vue?vue&type=style&index=0&id=a10ee058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10ee058",
  null
  
)

export default component.exports